import { createAsyncThunk,createSlice } from '@reduxjs/toolkit';
import { API } from '../../../api/services';

export const fetchDelectAccount: any = createAsyncThunk('deleteAccount/fetchList',
    async(id: any) =>{
        const response = await API.get(`/account-delete?account_id=${id}`);
        return response.data;
    }
 )

 const initialState = {
    deleteAccount: {},
 }

 const deleteAccountSlice = createSlice({
    name: 'deleteAccount',
    initialState,
    reducers: {
        setDeleteAccountState: (state, {payload}) =>{
            state.deleteAccount = payload;
        }
    }
 })
 export const {setDeleteAccountState} = deleteAccountSlice.actions;
 export default deleteAccountSlice.reducer;
    